import { FieldArray, getIn, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  AppFormDatePicker,
  AppFormFastField,
  AppFormSelectFastField,
  AppFormTextArea,
  AppFormTimePickerMui,
} from "../../../../AppComponents/Forms";
import { WhatsappNetworkService } from "../../../../Store/Slices/Whatsapp/WhatsappNetworkService";
import {
  getBodyComponentDetails,
  getButtonComponentDetails,
  getHeaderComponentDetails,
  makeStringFirstLetterUppercase,
} from "../../../../Utils";
import WhatsappMediaPicker from "../../../Broadcast/WhatsApp/Templates/components/WhatsappMediaPicker";
import {
  generateCarouselResolveVariables,
  generateButtonsResolveVariables,
  generateResolveVariables,
} from "../../../Broadcast/WhatsApp/Utils/utils";
import { theme } from "../../../../Customization/Theme";
import { ConversationService } from "../../../../Services/Apis/ConversationService";
import { useAuthStore } from "../../../../Store/Slices/AuthSlice";
import { useAppDispatch, useAppSelector } from "../../../../Store";
import { AxiosResponse } from "axios";
import { Drawer, Typography } from "@mui/material";
import CatalogueDrawer from "../../../../Modules/FlowBuilder/Nodes/WhatsApp/InteractiveCatalogue/catalogue-drawer";
import MultipleCatalogueDrawer from "../../../../Modules/FlowBuilder/Nodes/WhatsApp/InteractiveCatalogue/multipleCatalogue-drawer";
import AppButton from "../../../../AppComponents/AppButton";
import AllCatalogService from "../../../../Modules/FlowBuilder/Nodes/WhatsApp/InteractiveCatalogue/allcatalog";
import MultiCatalogService from "../../../../Modules/FlowBuilder/Nodes/WhatsApp/InteractiveCatalogue/multi-catalog";
import { values } from "lodash";
import MyMenuComponent from "../../../../AppComponents/Forms/NestedDropdown/MenuComponent";
import { automationBuilderState } from "../../../../Store/Slices/AutomationBuilder/automationBuilder.selectors";
import { ChatbotConsoleService } from "../../../../Services/Apis/ChatbotConsoleService";
import Index from "../../../AutomationBuilder/Index";
import { isObject } from "../../../../Modules/FlowBuilder/Components/Editor/utils/common";
import { useQueryBuilderStore } from "../../../../Store/Slices/QueryBuilder/QueryBuilder.selectors";
import { useParams } from "react-router-dom";
import { setActiveBot } from "../../../../Store/Slices/Whatsapp/whatsapp.slice";
import { getActiveBot } from "../../../../Store/Slices/Whatsapp/whatsapp.selectors";
import { getText } from "../../../../Modules/FlowBuilder/Utils";
import { getCorrectMediaSize } from "../../../../Modules/FlowBuilder/Nodes/WhatsApp/InteractiveMessage/helper";
const IMAGE_TYPES = ["image/jpeg", "image/png"];
const VIDEO_TYPES = ["video/mp4", "video/3gp"];
const AUDIO_TYPES = ["audio/aac", "audio/mp4", "audio/mpeg", "audio/amr"];
const STICKER_TYPES = ["image/webp"];

const DOCUMENT_TYPES = [
  "txt/plain",
  "application/pdf",
  "application/document",
  "application/vnd.ms-powerpoint",
  "application/msword",
  "application/vnd.ms-excel",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  "application/vnd.openxmlformats-officedocument.presentationml.presentation",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
];
const tempOption: any = {
  label: "Value + Text",
  name: "value_text",
  placeholder: "Enter Your value",
  type: "text",
  valueEditorType: "input",
};
const staticOptoins: any = [
  {
    label: "COPY CODE",
    name: "COPY_CODE",
  },
  {
    label: "QUICK REPLY",
    name: "QUICK_REPLY",
  },
  {
    label: "PHONE NUMBER",
    name: "PHONE_NUMBER",
  },
  {
    label: "URL",
    name: "URL"
  }
];
const getCorrectMediaFormats = (mediaType: string) => {
  if (mediaType === "VIDEO") {
    return VIDEO_TYPES;
  } else if (mediaType === "IMAGE") {
    return IMAGE_TYPES;
  } else if (mediaType === "DOCUMENT") {
    return DOCUMENT_TYPES;
  } else if (mediaType === "STICKER") {
    return STICKER_TYPES;
  } else if (mediaType === "AUDIO") {
    return AUDIO_TYPES;
  } else {
    return [];
  }
};
interface Props {
  applyValue?: any;
  applyCssClass?:any;
  allowEcomProperties?:boolean;
  preventRenderFields? : boolean
  excelHeaders ?: String[];
  removeStaticButtons?: boolean;
}

const WhatsappTemplatesResolveVaribles: React.FC<Props> = ({
  applyValue = false,
  applyCssClass = false,
  allowEcomProperties=false,
  preventRenderFields = false,
  excelHeaders,
  removeStaticButtons = false
}) => {
  const { values, setValues, setFieldValue } = useFormikContext<any>();
  let [filterFieldData, setFilterFieldData] = React.useState<any>([]);
  const { userConfig } = useAppSelector(useAuthStore);
  const [flowList, setFlowList] = useState<any>([]);
  const selectedTemplateData = getIn(values, "template");  
  const [openCatalogueDrawer, setOpenCatalogueDrawer] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState<any>(null);
  const automationReduxData: any = useAppSelector(automationBuilderState);
  const { queryBuilderFields,isGoogleSheetTrigger } = useAppSelector(useQueryBuilderStore);
  const params = useParams();
  const toggleCatalogueDrawer = () => {
    setOpenCatalogueDrawer(!openCatalogueDrawer);
  };

  useEffect(() => {
     if(isGoogleSheetTrigger){
      setFilterFieldData(queryBuilderFields)
    }else{
    WhatsappNetworkService.getFieldsTypeMappingList("", allowEcomProperties ? true : false).then((res: any) => {
      let mappingFields: any = res?.data?.mappingFields || [];
      let list = [tempOption, ...staticOptoins, ...mappingFields];
      console.log("🚀 ~ WhatsappTemplatesResolveVaribles ~ list:", list)
      setFilterFieldData(list);
    });}
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  console.log(filterFieldData, "filterFieldData")
  const HEADERS = {
    appid: JSON.stringify({
      botid: params?.bot_id ? params?.bot_id : userConfig?.payload?.whatasapp_config?.botid,
    }),
  };
  useEffect(() => {
    ConversationService.getFlowList(HEADERS)
      .then((res: AxiosResponse<any>) => {
        if (Array.isArray(res?.data?.data)) {
          setFlowList(res?.data?.data);
        } else {
          setFlowList([]);
        }
      })
      .catch((error: any) => { });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (getIn(values, "resolved_buttons_variables")) {
      getIn(values, "resolved_buttons_variables")?.map(
        (res: any, index: any) => {
          if (
            res.sub_type === "QUICK_REPLY" &&
            res.quick_reply_action === "Opt_out"
          ) {
            setFieldValue(
              `${"resolved_buttons_variables"}.${index}.payload`,
              "OPT-OUT-678-688"
            );
          }
          if (
            res.sub_type === "QUICK_REPLY" &&
            res.quick_reply_action === "connect_flow" &&
            res.payload === "OPT-OUT-678-688"
          ) {
            setFieldValue(
              `${"resolved_buttons_variables"}.${index}.payload`,
              ""
            );
          }
        }
      );
    }
  }, [getIn(values, "resolved_buttons_variables")]); // eslint-disable-line react-hooks/exhaustive-deps

  const headers = getHeaderComponentDetails(selectedTemplateData?.components);
  // console.log("getBodyComponentDetails", selectedTemplateData?.components);
  const body = getBodyComponentDetails(selectedTemplateData?.components);
  const buttons = getButtonComponentDetails(selectedTemplateData?.components);
  const carousel =
    selectedTemplateData?.original_response?.button_type === "carousel"
      ? generateCarouselResolveVariables(selectedTemplateData?.components,removeStaticButtons)
      : [];
  useEffect(() => {
    if (!applyValue) {
      const header_type: string =
        selectedTemplateData?.original_response?.header_type;
      const button_type: string =
        selectedTemplateData?.original_response?.button_type;
      const a =
        header_type === "TEXT"
          ? generateResolveVariables(headers?.text, headers?.header_text)
          : [];
      const c =
        header_type !== "TEXT" ? selectedTemplateData?.header_value : null;
      const b = generateResolveVariables(body?.text, body?.body_text) || [];
      const d: any[] = ["MEDIA", "IMAGE", "VIDEO", "DOCUMENT"].includes(header_type)
        ? [
          {
            key: "{{1}}",
            value: {},
            index: 0,
            type: header_type,
          },
        ]
        : a;

      const buttonsObj = [
        "copy_code_url_quick_replies_etc",
        "limited_time_offer",
        "otp",
      ].includes(button_type)
        ? generateButtonsResolveVariables(buttons)
        : null;


       // Process carousel data for QUICK_REPLY initialization
       if (carousel && Array.isArray(carousel) && carousel.length > 0) {
        carousel.forEach((card: any) => {
          if (card.buttons && Array.isArray(card.buttons) && card.buttons.length > 0) {
            card.buttons.forEach((button: any) => {
              if (button.type === "QUICK_REPLY" || button.sub_type === "QUICK_REPLY") {
                button.field = "QUICK_REPLY";
                button.field_value = button.text || "";
              }
            });
          }
        });
      }

      let newValues = {
        ...values,
        resolved_header_variables: d,
        header_media: c,
        header_type: header_type,
        header_media_type: selectedTemplateData?.header_type,
        header_value: selectedTemplateData?.original_response?.header_value || selectedTemplateData?.components?.filter((eachItem: any)=>eachItem?.type === "HEADER")?.[0]?.text,
        body_preview: body?.text,
        resolved_body_variables: b,
        resolved_buttons_variables: values?.template?.template_category === "AUTHENTICATION" || values?.template?.original_response?.button_type === "otp" ? [] : buttonsObj,
        resolved_carousel_variables: carousel,
        footer_value: selectedTemplateData?.footer_value,
        catalogue_variable:
          selectedTemplateData?.original_response?.catalogue_format || "",
      };

      if(automationReduxData) {

        const body_nodes = automationReduxData?.automationData?.draftedUIObject?.graphData?.nodes?.[automationReduxData?.selectedNodeId]?.nodeObjectData?.components?.body?.value
        const header_nodes = automationReduxData?.automationData?.draftedUIObject?.graphData?.nodes?.[automationReduxData?.selectedNodeId]?.nodeObjectData?.components?.header?.value
        const button_nodes = automationReduxData?.automationData?.draftedUIObject?.graphData?.nodes?.[automationReduxData?.selectedNodeId]?.nodeObjectData?.components?.button?.value
        const carousel_nodes = automationReduxData?.automationData?.draftedUIObject?.graphData?.nodes?.[automationReduxData?.selectedNodeId]?.nodeObjectData?.components?.carousel?.value
        // console.log("mynodes", body_nodes)
        if(body_nodes && !preventRenderFields)
          newValues['resolved_body_variables'] = body_nodes
        if(header_nodes && !preventRenderFields) {
            console.log("newValues['resolved_header_variables']", newValues['resolved_header_variables'])
            console.log("newValues['resolved_header_variables']",header_nodes)
            if(Array.isArray(newValues['resolved_header_variables']) && newValues['resolved_header_variables'].length > 0) {
              newValues['resolved_header_variables'][0]['value']['source'] = header_nodes
              newValues['resolved_header_variables'][0]['value']['name'] = header_nodes
            }
            // console.log("newValues['resolved_header_variables']", newValues['resolved_header_variables'])
            // newValues['resolved_header_variables'][0]['value'] = header_nodes
        }
        if(button_nodes && !preventRenderFields)
          newValues['resolved_buttons_variables'] = button_nodes
        if(carousel_nodes && !preventRenderFields)
          newValues['resolved_carousel_variables'] = carousel_nodes
      }
      if (button_type !== "carousel") delete newValues["carousel"];
      setValues(newValues);
    }
  }, [selectedTemplateData]); // eslint-disable-line react-hooks/exhaustive-deps

  // useEffect to Manage the selected product in Form State
  // useEffect(() => {
  //   if (selectedProduct?.length > 0) {
  //     setValues((prevValues: any) => ({
  //       ...prevValues,
  //       selected_product: selectedProduct, // Preserve previous values and update the product
  //     }));
  //   } else {
  //     setValues((prevValues: any) => ({
  //       ...prevValues,
  //       selected_product: null,
  //     }));
  //   }
  // }, [selectedProduct]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!selectedTemplateData && !applyValue) return null;
  if (
    getIn(values, "resolved_header_variables")?.length <= 0 &&
    getIn(values, "resolved_body_variables")?.length <= 0 &&
    getIn(values, "resolved_buttons_variables")?.length <= 0 &&
    getIn(values, "resolved_carousel_variables")?.length <= 0
  ) {
    return <p>No dynamic varibles found. kindly proceed further</p>;
  }

  const handleSelectedDataForAllCatalog = async (data: any) => {
    if (data?.length > 0) {
      setValues((prevValues: any) => ({
        ...prevValues,
        selected_product: data, // Preserve previous values and update the product
      }));
    } else {
      setValues((prevValues: any) => ({
        ...prevValues,
        selected_product: null,
      }));
    }
  }
  const handleSelectedDataForMultipalCatalog = async (data: any, thumbnailProduct: any) => {
    if (data?.length > 0) {
      setValues((prevValues: any) => ({
        ...prevValues,
        selected_product: data, // Preserve previous values and update the product
        thumbnailProduct: thumbnailProduct
      }));
    } else {
      setValues((prevValues: any) => ({
        ...prevValues,
        selected_product: null,
        thumbnailProduct: null
      }));
    }
  }  
  console.log("values",values);
  
  return (
    <StyledVariblesBox className="styledVariblesBox">
      {values?.header_type === "TEXT" && (
        <AppFormTextArea
          name={"header_value"}
          label="Header Preview"
          placeholder="header preview"
          rows={2}
          disabled={true}
        />
      )}
      <AppFormTextArea
        name={"body_preview"}
        label="Body Preview"
        placeholder="body preview"
        rows={3}
        disabled={true}
      />
      {values?.template?.original_response?.button_type ===
        "limited_time_offer" && (
          <React.Fragment>
            <AppFormDatePicker
              name={"limitedTimeOfferDate"}
              label="Select Date "
              minDate={new Date()}
            />
            <AppFormTimePickerMui
              name={"limitedTimeOfferTime"}
              label="Select Time "
              utcTime={true}
              disablePast={true}
            />
          </React.Fragment>
        )}
      {getIn(values, "resolved_header_variables")?.length > 0 ||
        getIn(values, "resolved_body_variables")?.length > 0 ||
        getIn(values, "resolved_carousel_variables")?.length > 0 ||
        getIn(values, "resolved_buttons_variables")?.length > 0 ? (
        <p className="variablesTitle">{"Resolve custom variables"}</p>
      ) : null}
      {getIn(values, "resolved_header_variables")?.length > 0 && (
        <RenderSingleTypeVariables
          name={"resolved_header_variables"}
          variableType={"Header"}
          mediaType={selectedTemplateData?.original_response?.header_type}
              isMedia={["MEDIA", "IMAGE", "VIDEO", "DOCUMENT"].includes(values?.header_type) ? true : false}
              fieldsData={
                values?.broadcast_action === "broadcast_via_csv" && excelHeaders?.length
                  ? excelHeaders.map(h => ({ label: h, name: h }))
                  : filterFieldData
              }
          flowList={flowList}
        />
      )}
      {getIn(values, "resolved_body_variables")?.length > 0 && (
        <RenderSingleTypeVariables
          name={"resolved_body_variables"}
          variableType="Body"
          fieldsData={
            values?.broadcast_action === "broadcast_via_csv" && excelHeaders?.length
              ? excelHeaders.map(h => ({ label: h, name: h }))
              : filterFieldData
          }
          flowList={flowList}
        />
      )}
      {getIn(values, "resolved_buttons_variables")?.length > 0 && (
        <RenderSingleTypeVariables
          name={"resolved_buttons_variables"}
          variableType="Buttons"
          fieldsData={filterFieldData}
          flowList={flowList}
        />
      )}
      {getIn(values, "resolved_carousel_variables")?.length > 0 && (
        <RenderCarouselTypeVariables
          name={"resolved_carousel_variables"}
          variableType="Carousel"
          fieldsData={filterFieldData}
        />
      )}

      {getIn(values, "catalogue_variable")?.length > 0 && selectedTemplateData?.original_response?.button_type === "catalogue" && (
        <RenderCatalogueTypeVariables values={values} selectedTemplateData={selectedTemplateData} openDrawer={toggleCatalogueDrawer} />
      )}

      <Drawer
        anchor="right"
        open={openCatalogueDrawer}
        onClose={() => toggleCatalogueDrawer()}
        className={applyCssClass ? "drawer-open" : "drawer-closed"}
        sx={{
          "& .MuiDrawer-paper": {
            width:
              selectedTemplateData?.original_response?.catalogue_format ===
                "MPM"
                ? "80%"
                : "500px",
            padding: "0px",
            overflow: "hidden",
            position: "fixed",
            zIndex: 1300
          },
        }}
      >
        {selectedTemplateData?.original_response?.catalogue_format === "MPM" ? (
          <MultiCatalogService
            open={openCatalogueDrawer}
            onClose={() => toggleCatalogueDrawer()}
            sendSelectedData={handleSelectedDataForMultipalCatalog}
            type={"product_list"}
            isThumbnail={true}
            selectedProductsList={values?.selected_product}
          // loading={loading}
          // products={products}
          // pagination={pagination}
          />
        ) : (
          <AllCatalogService
            open={openCatalogueDrawer}
            onClose={() => toggleCatalogueDrawer()}
            type="catalogue"
            sendSelectedData={handleSelectedDataForAllCatalog}
            selectedProductsList={values?.selected_product}
          />
        )}
      </Drawer>
    </StyledVariblesBox>
  );
};

export default WhatsappTemplatesResolveVaribles;

interface RenderSingalProps {
  variableType: string;
  name: string;
  isMedia?: boolean;
  fieldsData: any;
  mediaType?: string;
  flowList: any;
}
const RenderSingleTypeVariables: React.FC<RenderSingalProps> = ({
  variableType,
  name,
  isMedia = false,
  fieldsData = [],
  mediaType = "",
  flowList = [],
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const { userConfig } = useAppSelector(useAuthStore);
  const params = useParams();
  const [childNodes, setChildNodes] = useState<{[key: number]: any[]}>({});
  if (getIn(values, name)?.length === 0) {
    return null;
  }
  let data = [
    {
      label: "Connect Flow",
      name: "connect_flow",
    },
    {
      label: "Opt out",
      name: "Opt_out",
    },
  ];
  const getChildNodeList = (data: any, index: number) => {
    const HEADERS = {
      appid: JSON.stringify({
        botid: params?.bot_id ? params?.bot_id : userConfig?.payload?.whatasapp_config?.botid,
      }),
    };
    setChildNodes(prev => ({ ...prev, [index]: [] }));
    ConversationService.getChildFlowList(data, HEADERS)
      .then((res: AxiosResponse<any>) => {
        if (Array.isArray(res?.data?.data)) {
          setChildNodes(prev => ({ ...prev, [index]: res?.data?.data }));
        } else {
          setChildNodes(prev => ({ ...prev, [index]: [] }));
        }
      })
      .catch((error: any) => { });
  };

  function setValueFromResponse(data: any) {
    // Check if data is an array before calling forEach
    if (!Array.isArray(data)) {
      return data || [];
    }
    
    // Loop through each object in the data array
    data.forEach((item: any) => {
      // Check if the item has a response array and if the first response has a value
      const responseValue =
        item?.response?.[0]?.value || item?.response?.[0]?.interactive?.body;
      if(isObject(responseValue)){
        item.value = responseValue?.address
      }else {
        if(responseValue){
          item.value = responseValue;
        }
      }
    });

    return data;
  }
  // console.log("valuessss", values)

  const handleMenuClickCallback = (index: any, key: any, resolve_index: any = null, resolve_key: any = null) => {
    // console.log(index, key)
    // console.log(resolve_index, resolve_key)
    if (index && key) {
      setFieldValue(index, key)
    }
    if (resolve_index && resolve_key) {
      setFieldValue(resolve_index, resolve_key)
    }
  }

  return (
    <React.Fragment>
      <p className="variablesType">
        {makeStringFirstLetterUppercase(variableType)}:
      </p>

      <FieldArray name={name}>
        {() => (
          <React.Fragment>
            {getIn(values, name)?.length > 0 &&
              getIn(values, name)?.map((item: any, index: number) => {
                const textfieldName: string = `${name}.${index}.value`;
                const selectfieldName: string = `${name}.${index}.index`;
                const selectResolveFieldName: string = `${name}.${index}.resolve_index`;
                const quickReplyAction: string = `${name}.${index}.quick_reply_action`;
                const payload: string = `${name}.${index}.payload`;
                const parentPayload: string = `${name}.${index}.parentPayload`;
                const headerType = item?.type?.toLowerCase();
                if (item?.sub_type === "URL" && !item.hasOwnProperty("key"))
                  return null;
                return (
                  <React.Fragment>
                    {variableType === "Buttons" && (
                      <p>
                        {"Type:    " + item?.sub_type?.replaceAll("_", " ")}
                      </p>
                    )}
                    {item?.sub_type?.replaceAll("_", " ") === "QUICK REPLY" && (
                      <div style={{ marginLeft: "40px" }}>
                        <p
                          className="variableIndex"
                          style={{ fontWeight: "500", fontSize: "15px" }}
                        >
                          {" "}
                          Select Action :-{" "}
                        </p>
                        <AppFormSelectFastField
                          Options={data}
                          name={quickReplyAction}
                          valueKey="name"
                        />
                        {item?.quick_reply_action === "connect_flow" ? (
                          <>
                            <AppFormSelectFastField
                              Options={flowList}
                              name={parentPayload}
                              valueKey="qid"
                              onChangeCallbackFn={(data: any) => getChildNodeList(data, index)}
                            />
                            {childNodes[index] && childNodes[index]?.length !== 0 ? (
                              <AppFormSelectFastField
                                Options={setValueFromResponse(childNodes[index])}
                                name={payload}
                                valueKey="nodeId"
                                displayKey="value"
                              />
                            ) : null}
                          </>
                        ) : null}
                      </div>
                    )}
                    <div className="variablesContentt" key={index.toString()}>
                      <p className="variableIndex">{`{{${index + 1}}}`}</p>
                      {isMedia ? (
                        <WhatsappMediaPicker
                          name={textfieldName}
                          isResolveVariable={true}
                          supportedFormat={getCorrectMediaFormats(mediaType)}
                          mediaType={mediaType}
                          divStyle={{ marginTop: "0.3rem" }}
                          tooltipTitle={`The supported format is ${item?.header?.type?.toLowerCase() || item?.type?.toLowerCase() || 'media'} file size must be smaller than ${(getCorrectMediaSize(item?.header?.type?.toLowerCase() || item?.type?.toLowerCase() || 'media')) / 1000000} MB.`}
                        />
                      ) : (
                        <React.Fragment>
                          {fieldsData?.length > 0 && (
                            // <AppFormSelectFastField
                            //   Options={fieldsData}
                            //   name={selectfieldName}
                            //   valueKey="name"
                            //   disabled={item?.disable}
                            //   disabledOptionsList={[
                            //     "COPY_CODE",
                            //     "QUICK_REPLY",
                            //     "PHONE_NUMBER",
                            //   ]}
                            // />
                            <MyMenuComponent 
                              menus={fieldsData}
                              disabledOptionsList={["COPY_CODE", "QUICK_REPLY", "PHONE_NUMBER"]}
                              name={selectfieldName}
                              defaultValue={item?.index}
                              onChangeCallbackFn={(name: any, resolve_name: any = null) => handleMenuClickCallback(selectfieldName, name, selectResolveFieldName, resolve_name)}
                              />
                          )}
                          <AppFormFastField
                            name={textfieldName}
                            placeholder={
                              getIn(values, selectfieldName) === "value_text"
                                ? "Static value"
                                : "Fallback Value"
                            }
                            disabled={
                              ["QUICK_REPLY", "MPM", "CATALOG"].includes(
                                item?.sub_type
                              )
                                ? true
                                : false
                            }
                            divStyle={{gap: 0}}
                          />
                        </React.Fragment>
                      )}
                    </div>
                  </React.Fragment>
                );
              })}
          </React.Fragment>
        )}
      </FieldArray>
    </React.Fragment>
  );
};

// Carouasel Component
interface RenderCarouselProps {
  variableType: string;
  name: string;
  fieldsData: any;
  mediaType?: string;
}


const ButtonRenderer = ({
  buttonEle,
  buttonIndex,
  name,
  index,
  flowList,
  getChildNodeList,
  values,
}: any) => {
  const quickReplyAction = `${name}.${index}.buttons.${buttonIndex}.quick_reply_action`;
  const payload = `${name}.${index}.buttons.${buttonIndex}.payload`;
  const parentPayload = `${name}.${index}.buttons.${buttonIndex}.parentPayload`;

  const [botId, setBotId] = useState<any>();


  useEffect(() => {
    ChatbotConsoleService.getAllBots().then((res: any) => {
      if (res.data?.results?.length > 0) {
        let activeBot = res.data.results.filter((el: any) => el.channel === "whatsapp" && el.bot_enabled === true);
        if(activeBot.length){
          setBotId(activeBot[0].bot_id)
        }
      }
    })
    if (
      buttonEle?.quick_reply_action === "connect_flow" &&
      getIn(values, parentPayload)
    ) {
      getChildNodeList(getIn(values, parentPayload));
    }
  }, [buttonEle?.quick_reply_action, values, parentPayload, flowList]);

  return (
    <div>
    </div>
  );
};

const RenderCarouselTypeVariables: React.FC<RenderCarouselProps> = ({
  variableType,
  name,
  fieldsData = [],
  mediaType = "",
}) => {
  const { values, setFieldValue } = useFormikContext<any>();
  const [activeBotId, setActiveBotId] = useState<string | null>(null);
  const { userConfig } = useAppSelector(useAuthStore);
  const [flowList, setFlowList] = useState<any>([]);
  const dispatch = useAppDispatch();
  const activeBot = useAppSelector(getActiveBot);
  const [childNodes, setChildNodes] = useState<{[key: string]: any[]}>({});
  useEffect(() => {
    ChatbotConsoleService.getAllBots().then((res: any) => {
      if (res.data?.results?.length > 0) {
        let activeBot = res.data.results.filter((el: any) => el.channel === "whatsapp" && el.bot_enabled === true);
        if(activeBot.length){
          setActiveBotId(activeBot[0].bot_id)
          dispatch(setActiveBot(activeBot[0].bot_id))
        }
      }
    })
  }, []);
  
  useEffect(() => {
    if(activeBotId){
      const HEADERS = {
        appid: JSON.stringify({
          botid: activeBotId,
        }),
      };
      ConversationService.getFlowList(HEADERS)
        .then((res: AxiosResponse<any>) => {
          if (Array.isArray(res?.data?.data)) {
            setFlowList(res?.data?.data);
          } else {
            setFlowList([]);
          }
        })
        .catch((error: any) => {});
    }
  }, [activeBotId]);
  
  const getChildNodeList = (data: any, key: string) => {
    const HEADERS = {
      appid: JSON.stringify({
        botid: activeBotId || activeBot,
      }),
    };
    setChildNodes(prev => ({ ...prev, [key]: [] }));
    ConversationService.getChildFlowList(data, HEADERS)
      .then((res: AxiosResponse<any>) => {
        if (Array.isArray(res?.data?.data)) {
          setChildNodes(prev => ({ ...prev, [key]: res?.data?.data }));
        } else {
          setChildNodes(prev => ({ ...prev, [key]: [] }));
        }
      })
      .catch((error: any) => {});
  };
  
  // Set default values for QUICK_REPLY fields
  useEffect(() => {
    if (getIn(values, name)?.length > 0) {
      getIn(values, name).forEach((item: any, index: number) => {
        if (item?.buttons?.length > 0) {
          item.buttons.forEach((button: any, buttonIndex: number) => {
            if (button.type === "QUICK_REPLY" || button.sub_type === "QUICK_REPLY") {
              const selectfieldName: string = `${name}.${index}.buttons.${buttonIndex}.field`;
              const selectfieldValue: string = `${name}.${index}.buttons.${buttonIndex}.field_value`;
              // Set default values
              setFieldValue(selectfieldName, "QUICK_REPLY");
              setFieldValue(selectfieldValue, button.text || "");
            } else if (button.type === "PHONE_NUMBER" || button.sub_type === "PHONE_NUMBER") {
              const selectfieldName: string = `${name}.${index}.buttons.${buttonIndex}.field`;
              const selectfieldValue: string = `${name}.${index}.buttons.${buttonIndex}.field_value`;
              // Set default values
              setFieldValue(selectfieldName, "PHONE_NUMBER");
              setFieldValue(selectfieldValue, button.text || "");
            }
          });
        }
      });
    }
  }, [getIn(values, name)]); // eslint-disable-line react-hooks/exhaustive-deps
  if (getIn(values, name)?.length === 0) {
    return null;
  }

  const handleMenuClickCallback = (array_index: any, array_key: any, index: any, key: any, resolve_index: any = null, resolve_key: any = null) => {
    if (index && key) {
      setFieldValue(index, key);
    }
    if (resolve_index && resolve_key) {
      setFieldValue(resolve_index, resolve_key);
    }
  }

  return (
    <React.Fragment>
      <p className="variablesType">
        {makeStringFirstLetterUppercase(variableType)}:
      </p>

      <FieldArray name={name}>
        {() => (
          <React.Fragment>
            {getIn(values, name)?.length > 0 &&
              getIn(values, name)?.map((item: any, index: number) => {
                const headerName: string = `${name}.${index}.header.value`;
                const headerType = item?.header?.type?.toLowerCase();
                return (
                  <div
                    className="carouselVariablesContent"
                    key={index.toString()}
                  >
                    {/* Header */}
                    <p>{`Card:  ${index + 1}`}</p>
                    <div className="headerContainer">
                      <p className="carousel_title">
                        Header ({item?.header?.type})
                      </p>
                      <div className="header_field_container">
                        <p className="variableIndex">
                          {item?.header?.key as string}
                        </p>
                        <WhatsappMediaPicker
                          name={headerName}
                          isResolveVariable={true}
                          supportedFormat={getCorrectMediaFormats(
                            item?.header?.type?.toUpperCase()
                          )}
                          mediaType={mediaType}
                          divStyle={{ marginTop: "0.3rem" }}
                          tooltipTitle={`The supported format is ${item?.header?.type?.toLowerCase() || item?.type?.toLowerCase() || 'media'} file size must be smaller than ${(getCorrectMediaSize(item?.header?.type?.toLowerCase() || item?.type?.toLowerCase() || 'media')) / 1000000} MB.`}
                        />
                      </div>
                    </div>

                    {/* Body */}
                    {item?.body?.value?.length > 0 && (
                      <p className="carousel_title">Body</p>
                    )}
                    <React.Fragment>
                      {item?.body?.value?.length > 0 &&
                        item?.body?.value?.map((bodyEle: any, bodyIndex: number) => {
                          const selectfieldName: string = `${name}.${index}.body.value.${bodyIndex}.index`;
                          const selectfieldValue: string = `${name}.${index}.body.value.${bodyIndex}.value`;
                          const selectResolveFieldName: string = `${name}.${index}.body.value.${bodyIndex}.resolve_index`;
                          return (
                            <div className="carouselFields" key={bodyIndex}>
                              <p className="variableIndex">
                                {bodyEle?.key as string}
                              </p>
                              {fieldsData?.length > 0 && (
                                <MyMenuComponent 
                                  menus={fieldsData}
                                  disabledOptionsList={["COPY_CODE", "QUICK_REPLY", "PHONE_NUMBER"]}
                                  name={selectfieldName}
                                  defaultValue={bodyEle?.index}
                                  onChangeCallbackFn={(name: any, resolve_name: any = null) => handleMenuClickCallback(index, "body", selectfieldName, name, selectResolveFieldName, resolve_name)}
                                />
                              )}
                              <AppFormFastField
                                name={selectfieldValue}
                                placeholder={
                                  getIn(values, selectfieldName) === "value_text"
                                    ? "Static value"
                                    : "Fallback Value"
                                }
                              />
                            </div>
                          );
                        })}
                    </React.Fragment>

                    {/* Buttons  */}
                    {item?.buttons?.length > 0 && (
                      <p className="carousel_title">Buttons</p>
                    )}
                    <React.Fragment>
                      {item?.buttons?.length > 0 &&
                        item?.buttons?.map(
                          (buttonEle: any, buttonIndex: number) => {
                            const selectfieldName: string = `${name}.${index}.buttons.${buttonIndex}.field`;
                            const selectfieldValue: string = `${name}.${index}.buttons.${buttonIndex}.field_value`;
                            const quickReplyAction: string = `${name}.${index}.buttons.${buttonIndex}.quick_reply_action`;
                            const payload: string = `${name}.${index}.buttons.${buttonIndex}.payload`;
                            const parentPayload: string = `${name}.${index}.buttons.${buttonIndex}.parentPayload`;
                              // Skip rendering buttons with type URL - need to confirm prasad
                              if ((buttonEle?.sub_type === "URL" || buttonEle?.type === "URL") && !buttonEle?.key) {
                                return null;
                              }
                            
                            return (
                              

                              <div key={buttonIndex}>
                                <p>
                                  {"Type:    " + (buttonEle?.sub_type || buttonEle?.type)?.replaceAll("_", " ")}
                                </p>{(buttonEle?.sub_type === "QUICK_REPLY" || buttonEle?.type === "QUICK_REPLY") && (
                                  <div style={{ marginLeft: "40px" }}>
                                    <p
                                      className="variableIndex"
                                      style={{ fontWeight: "500", fontSize: "15px" }}
                                    >
                                      Select Action :-{" "}
                                    </p>
                                    <AppFormSelectFastField
                                      Options={[
                                        {
                                          label: "Connect Flow",
                                          name: "connect_flow",
                                        },
                                        {
                                          label: "Opt out",
                                          name: "Opt_out",
                                        },
                                      ]}
                                      name={quickReplyAction}
                                      valueKey="name"
                                    />

                                    {item?.buttons?.map((buttonEle: any, buttonIndex: any) => (
                                      <ButtonRenderer
                                        key={buttonIndex}
                                        buttonEle={buttonEle}
                                        buttonIndex={buttonIndex}
                                        name={name}
                                        index={index}
                                        flowList={flowList}
                                        getChildNodeList={getChildNodeList}
                                        values={values}
                                      />
                                    ))}
                                    {buttonEle?.quick_reply_action === "connect_flow" ? (
                                      <>
                                        <AppFormSelectFastField
                                          Options={flowList || []}
                                          name={parentPayload}
                                          valueKey="qid"
                                          onChangeCallbackFn={(data: any) => getChildNodeList(data, `${index}-${buttonIndex}`)}
                                        />{" "}
                                        {childNodes[`${index}-${buttonIndex}`] && childNodes[`${index}-${buttonIndex}`]?.length !== 0 ? (
                                          <AppFormSelectFastField
                                            Options={childNodes[`${index}-${buttonIndex}`]}
                                            name={payload}
                                            valueKey="nodeId"
                                          />
                                        ) : null}{" "}
                                      </>
                                    ) : null}
                                  </div>
                                )}
                                <div className="carouselFields">
                                  <p className="variableIndex">
                                    {buttonEle?.key ? buttonEle?.key : `{{${buttonIndex + 1}}}`}
                                  </p>
                                  {!(buttonEle?.sub_type === "QUICK_REPLY" || buttonEle?.type === "QUICK_REPLY") && 
                                   !(buttonEle?.sub_type === "PHONE_NUMBER" || buttonEle?.type === "PHONE_NUMBER") && (
                                    <>
                                      {fieldsData?.length > 0 && (
                                        <AppFormSelectFastField
                                          Options={fieldsData}
                                          name={selectfieldName}
                                          valueKey="name"
                                        />
                                      )}
                                      <AppFormFastField
                                        name={selectfieldValue}
                                        placeholder={
                                          getIn(values, selectfieldName) ===
                                          "value_text"
                                            ? "Static value"
                                            : "Fallback Value"
                                        }
                                      />
                                    </>
                                  )}
                                  {(buttonEle?.sub_type === "QUICK_REPLY" || buttonEle?.type === "QUICK_REPLY") && (
                                    <>
                                      {fieldsData?.length > 0 && (
                                        <AppFormSelectFastField
                                          Options={fieldsData}
                                          name={selectfieldName}
                                          valueKey="name"
                                          disabled={true}
                                          disabledOptionsList={[
                                            "COPY_CODE",
                                            "QUICK_REPLY",
                                            "PHONE_NUMBER"
                                          ]}
                                        />
                                      )}
                                      <AppFormFastField
                                        name={selectfieldValue}
                                        placeholder="Fallback Value"
                                        disabled={true}
                                      />
                                    </>
                                  )}
                                  {(buttonEle?.sub_type === "PHONE_NUMBER" || buttonEle?.type === "PHONE_NUMBER") && (
                                    <>
                                      {fieldsData?.length > 0 && (
                                        <AppFormSelectFastField
                                          Options={fieldsData}
                                          name={selectfieldName}
                                          valueKey="name"
                                          disabled={true}
                                          disabledOptionsList={[
                                            "COPY_CODE",
                                            "QUICK_REPLY",
                                            "PHONE_NUMBER"
                                          ]}
                                        />
                                      )}
                                      <AppFormFastField
                                        name={selectfieldValue}
                                        placeholder="Fallback Value"
                                        disabled={true}
                                      />
                                    </>
                                  )}
                                </div>
                                </div>
                            );
                          }
                        )}
                    </React.Fragment>
                  </div>
                );
              })}
          </React.Fragment>
        )}
      </FieldArray>
    </React.Fragment>
  );
};

const RenderCatalogueTypeVariables: React.FC<any> = ({ openDrawer,selectedTemplateData,values }) => {
  return (
    <React.Fragment>
      {selectedTemplateData?.original_response?.catalogue_format !== "MPM" ? <div>
        <img style={{ width: "35%" }} src={values?.selectedProducts?.[0]?.
          image_url
        }></img>
        <Typography variant="body2">
          {values?.selectedProducts?.length > 0 ? values?.selectedProducts?.[0]?.name : ""}
        </Typography>
      </div> : null}
      <AppButton
        onClick={() => {
          openDrawer(true);
        }}
        style={{
          marginTop: "1rem",
          marginBottom: "1rem",
          width: "250px",
          margin: "auto",
        }}
      >
        Select Product
      </AppButton>
    </React.Fragment>
  );
};

const StyledVariblesBox = styled.div`
  && {

    .variablesTitle {
      font-size: 16px;
      font-weight: 500;
    }

    .variablesType {
      font-size: 15px;
      font-weight: 500;
    }
    .variablesContentt {
      display: flex;
      align-items: flex-start;
      gap: 1rem;

      .variableIndex {
        padding-top: 0.8rem;
        display: flex;
        height: 100%;
      }
    }
    .carouselVariablesContent {
      gap: 1rem;
      border-bottom: 1px solid ${theme.palette.default.border};
      &:last-child {
        border-bottom: none; /* Hide border-bottom for the last element */
        margin-bottom: 0; /* Adjust margin if necessary */
      }
      margin-bottom: 1rem;
      .variableIndex {
        padding-top: 0.8rem;
        display: flex;
        height: 100%;
      }
      .carouselFields {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
      }
      .header_field_container {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
      }
    }
    .StyledUploadedImageWrap {
      margin: 0px;
    }
    .MediaUploadBox {
      margin: 0px;
    }
    .headerContainer {
      display: block;
      width: 100%;
    }
    .carousel_title {
      font-size: 15px;
      font-weight: 500;
      margin: 0.5rem 0;
    }
  }
`;
